<template>
    <v-col cols="12" sm="12">
        <v-container class="app-container">
            <home-title :title="$t('manufacturers')"></home-title>

            <v-slide-group show-arrows>
                <v-slide-item
                    v-for="manufacturer in manufacturersInfo"
                    :key="manufacturer.id"
                    v-slot:default="{ active, toggle }"
                >
                    <router-link
                        :to="manufacturer.link"
                    >
                        <v-img
                            :src="manufacturer.image"
                            contain
                            class="ma-9"
                            width="100"
                            height="150"
                            @click="toggle"
                        ></v-img>
                    </router-link>
                </v-slide-item>
            </v-slide-group>
        </v-container>
    </v-col>
</template>

<script>
    import HomeTitle from './HomeTitle';
    import Partners from '../../../app-front/mixins/Partners';

    export default {
        name: 'HomeManufacturers',
        mixins: [Partners],
        components: {
            HomeTitle
        },
        data() {
            return {
                manufacturersImages: [
                    {id: 1, src: '//cdn.farmzi.net/images/banners/adama.png'},
                    {id: 2, src: '//cdn.farmzi.net/images/banners/Ekoplon.png'},
                    {id: 3, src: '//cdn.farmzi.net/images/banners/ChimAgro.jpg'},
                    {id: 4, src: '//cdn.farmzi.net/images/banners/Ukrpolehim.png'},
                    {id: 5, src: '//cdn.farmzi.net/images/banners/Rodonit.png'},
                    {id: 6, src: '//cdn.farmzi.net/images/banners/August.png'},
                    {id: 7, src: '//cdn.farmzi.net/images/banners/AXT.png'},
                    {id: 8, src: '//cdn.farmzi.net/images/banners/BELOR_logotipas-1.png'},
                    {id: 9, src: '//cdn.farmzi.net/images/banners/Agrotheka.png'},
                    {id: 11, src: '//cdn.farmzi.net/images/banners/bio-norma.png'},
                    {id: 12, src: '//cdn.farmzi.net/images/banners/pest-ua.png'},
                ],
            }
        },
    }
</script>

<style scoped>

</style>
